export default {
  "shouldReduceMotion": "_shouldReduceMotion_5to59_9",
  "page": "_page_5to59_14",
  "pageWithOpenedSidePanel": "_pageWithOpenedSidePanel_5to59_20",
  "pageWithExpandedSidePanel": "_pageWithExpandedSidePanel_5to59_24",
  "sidePanel": "_sidePanel_5to59_29",
  "enter": "_enter_5to59_39",
  "enterActive": "_enterActive_5to59_42",
  "enterDone": "_enterDone_5to59_43",
  "exit": "_exit_5to59_48",
  "exitActive": "_exitActive_5to59_51",
  "exitDone": "_exitDone_5to59_52",
  "appear": "_appear_5to59_57",
  "appearActive": "_appearActive_5to59_61",
  "appearDone": "_appearDone_5to59_62"
};import "ni:sha-256;WtzhUuYcSXdbfCxTEiv2UpqroRoVGyA0d_9vHNrW1bo";